import styled from "styled-components";
import { Box } from "grommet";

const FrostedGlassBox = styled(Box)`
.container {
  border-radius: 5px;
  position: relative;
  z-index: 1;
  background: inherit;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(74, 79, 107, 0.30) 0%, rgba(35, 37, 50, 0.30) 100%);
  box-shadow: 0px 25px 50px 0px rgba(1, 5, 22, 0.50);
  backdrop-filter: blur(50px);
}

.container:before {
  content: "";
  
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  filter: blur(10px);
  
  background: linear-gradient(180deg, rgba(74, 79, 107, 0.50) 0%, rgba(35, 37, 50, 0.50) 100%);
  box-shadow: 0px 25px 50px 0px rgba(1, 5, 22, 0.50);
  backdrop-filter: blur(50px);
}
`

export { FrostedGlassBox }